{
  "version": 1,
  "asset_id": "94361e2d-c20e-4f0c-9713-ca9f8ac11099",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/94361e2d-c20e-4f0c-9713-ca9f8ac11099/biocompatibility-biological-evaluation-hero.jpg",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/94361e2d-c20e-4f0c-9713-ca9f8ac11099/biocompatibility-biological-evaluation-hero.jpg",
  "original_filename": "biocompatibility-biological-evaluation-hero.jpg",
  "size": 681205,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T10:39:45Z"
}
